import { ModuleWithProviders, Inject, Optional, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmCoreModule, LAZY_MAPS_API_CONFIG, MapsAPILoader } from '@agm/core';
import { LazyMapsAPILoader, LazyMapsAPILoaderConfigLiteral } from '@agm/core/services/maps-api-loader/lazy-maps-api-loader';
import { WindowRef, DocumentRef, BROWSER_GLOBALS_PROVIDERS } from '@agm/core/utils/browser-globals';



@NgModule({ imports: [CommonModule, AgmCoreModule], exports: [AgmCoreModule]})
export class AgmOverrideModule {
  static forRoot(lazyMapsAPILoaderConfig?: LazyMapsAPILoaderConfigLiteral): ModuleWithProviders {
    return {
      ngModule: AgmOverrideModule, providers: [BROWSER_GLOBALS_PROVIDERS, { provide: MapsAPILoader, useClass: ApiLoader },
        { provide: LAZY_MAPS_API_CONFIG, useValue: lazyMapsAPILoaderConfig } ]}
  }
}

export class ApiLoader extends LazyMapsAPILoader {
  private static loaded: boolean;
  constructor( @Optional() @Inject(LAZY_MAPS_API_CONFIG) config: any, @Inject(WindowRef) w: WindowRef, @Inject(DocumentRef)  d: DocumentRef) {
    super(config, w, d);
    
  }
  load(): Promise<void> {
    if (ApiLoader.loaded) {
      return new Promise<void>(resolve => resolve());
    } else {
      return new Promise<void>((resolve, reject) => {
        super.load()
          .then(() => {
            ApiLoader.loaded = true;
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/maps/agm-override.module.ts